<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsTransportationEmissions.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'
import {
  getBin,
  getBins,
  getInterval,
  initializeHistogram,
  initializeHistograms,
  histogramIsZero,
  getMaxDistance
} from './utils.js'

export default {
  name: 'TransportationEmissions',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      options: {}
    }
  },
  methods: {
    compute () {
      let self = this
      let max = getMaxDistance(this.ghgi.travels)
      let categories = getBins(max)
      let histograms = initializeHistograms(max)
      let total = initializeHistogram(max)

      for (let travel of this.ghgi.travels) {
        for (let section of travel.sections) {
          // round trip nature are handled by getCarbonIntensity
          let distance = section.getOneWayCorrectedDistance()
          let intensity = section
            .getCarbonIntensity(this.ghgi.year)
            .multiply(travel.amount).intensity
          let bin = getBin(distance)
          histograms[section.transportation][bin] += intensity
          total[bin] += intensity
        }
      }
      let totalCumSum = Object.values(total)
      for (let i = 1; i < totalCumSum.length; i++) {
        totalCumSum[i] += totalCumSum[i - 1]
      }

      let series = []
      for (let mode in histograms) {
        if (histogramIsZero(histograms[mode])) {
          continue
        }
        series.push({
          name: self.$t(mode),
          type: 'column',
          data: Object.values(histograms[mode])
        })
      }
      series.push({
        name: self.$t('compGraphicsTransportationEmissions.label-total'),
        type: 'line',
        data: totalCumSum,
        yAxis: 1,
        color: '#FF0000'
      })

      this.options = {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: categories,
          crosshair: true,
          title: {
            text: self.$t('compGraphicsTransportationEmissions.label-xaxis')
          }
        },
        yAxis: [
          {
            gridLineWidth: 0,
            title: {
              text: self.$t('compGraphicsTransportationEmissions.label-yaxis-0')
            }
          },
          {
            title: {
              text: self.$t('compGraphicsTransportationEmissions.label-yaxis-1')
            },
            endOnTick: false,
            opposite: true
          }
        ],
        tooltip: {
          formatter: function () {
            let [inf, sup] = getInterval(this.points[0].x)
            let tooltip = inf + ' km - ' + sup + ' km <br/>'
            for (let i in this.points) {
              tooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                ';">\u25CF ' +
                '</span> '
              tooltip +=
                this.points[i].series.name +
                ': <b>' +
                Math.floor(this.points[i].y) +
                ' </b><br/>'
            }
            return tooltip
          },
          shared: true
        },
        series: series,
        legend: {
          enabled: true
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            groupPadding: 0,
            pointPadding: 0
          }
        }
      }
    }
  },
  mounted () {
    let self = this
    this.compute()
    setTimeout(function () {
      self.$refs.chart.chart.redraw()
    }, 1)
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
